import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import isEmpty from "lodash/isEmpty";

// Components
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import SuccessWrap from "../../utils/error-success/SuccessWrap";
import Button from "../../utils/Button";

// State
import { userTokenUpdate } from "../../../store/actions/user";
import { getBanners } from "../../../store/actions/banners";

// Utils
import { handleKeyPress, handleInputChange } from "../../../utils/forms/inputHandling";

class BannerItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			updateLoading: false,
			updateSuccess: "",
			updateErrors: {},
			deleteLoading: false,
			data: this.props.banner
		};
	}

	handleSubmit = () => {
		const { data } = this.state;
		const { user } = this.props;

		this.setState({
			updateSuccess: "",
			updateErrors: {},
			updateLoading: true
		});

		const token = user.token;
		const AUTH_HEADER = { Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.post(process.env.REACT_APP_API_URL + "banners/" + data.id, data, {
				headers: AUTH_HEADER
			})
			.then(response => {
				if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({
						updateLoading: false,
						updateErrors: !isEmpty(response.data.errors)
							? response.data.errors
							: { general: response.data.message }
					});
				} else {
					this.setState({
						updateLoading: false,
						updateSuccess: response.data.message
					});

					this.props.userTokenUpdate("admin", response.data.token);
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						updateLoading: false,
						updateErrors: {
							general: err.response.data.error
								? err.response.data.error
								: err.response.data.message
						}
					});
				} else {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.message }
					});
				}
			});
	};

	handleDelete = () => {
		const { data } = this.state;
		const { user } = this.props;

		this.setState({
			updateSuccess: "",
			updateErrors: {},
			deleteLoading: true
		});

		const token = user.token;
		const AUTH_HEADER = { Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.delete(process.env.REACT_APP_API_URL + "banners/" + data.id, {
				headers: AUTH_HEADER
			})
			.then(response => {
				if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({
						updateLoading: false,
						updateErrors: !isEmpty(response.data.errors)
							? response.data.errors
							: { general: response.data.message }
					});
				} else {
					this.setState({
						updateLoading: false,
						updateSuccess: response.data.message
					});

					this.props.userTokenUpdate("admin", response.data.token);
					this.props.getBanners();
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						updateLoading: false,
						updateErrors: {
							general: err.response.data.error
								? err.response.data.error
								: err.response.data.message
						}
					});
				} else {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.message }
					});
				}
			});
	};

	render() {
		const { sizes, href, alt } = this.state.data;
		const { updateErrors, updateSuccess, updateLoading } = this.state;

		return (
			<div className="form-field grouped-field">
				<div>
					{sizes.full && (
						<div className="image-preview-container">
							<div className="text-section">
								<div>Full Size</div>
							</div>
							<div className="image-display">
								<img
									src={process.env.REACT_APP_RESOURCE_URL + sizes.full.src}
									alt={process.env.REACT_APP_RESOURCE_URL + sizes.full.src}
								/>
							</div>
						</div>
					)}

					{sizes.mobile && (
						<div className="image-preview-container">
							<div className="text-section">
								<div>Mobile</div>
							</div>
							<div className="image-display">
								<img
									src={process.env.REACT_APP_RESOURCE_URL + sizes.mobile.src}
									alt={process.env.REACT_APP_RESOURCE_URL + sizes.mobile.src}
								/>
							</div>
						</div>
					)}
				</div>

				<div className="form-field">
					<label>URL</label>

					{updateErrors.href && <ErrorWrap animate={1}>{updateErrors.href}</ErrorWrap>}
					<input
						type="url"
						id="href"
						value={href}
						placeholder="http://www.website.com"
						disabled={updateLoading}
						onKeyPress={e => handleKeyPress(e, this.handleSubmit)}
						onChange={e => this.setState(handleInputChange(e, this.state))}
					/>
				</div>

				<div className="form-field">
					<label>Alt</label>

					{updateErrors.alt && <ErrorWrap animate={1}>{updateErrors.alt}</ErrorWrap>}
					<input
						type="text"
						id="alt"
						value={alt}
						placeholder="Image Alternate Text"
						disabled={updateLoading}
						onKeyPress={e => handleKeyPress(e, this.handleSubmit)}
						onChange={e => this.setState(handleInputChange(e, this.state))}
					/>
				</div>

				<div className="btn_container">
					{updateErrors.general && (
						<ErrorWrap animate={1}>{updateErrors.general}</ErrorWrap>
					)}
					{updateSuccess && <SuccessWrap animate={1}>{updateSuccess}</SuccessWrap>}
					<Button
						text={"Update"}
						clickHandler={this.handleSubmit}
						isLoading={this.state.updateLoading}
						isDisabled={this.state.updateLoading || this.state.deleteLoading}
					/>
					<Button
						text={"Delete"}
						classes={"delete-btn"}
						clickHandler={this.handleDelete}
						isLoading={this.state.deleteLoading}
						isDisabled={this.state.updateLoading || this.state.deleteLoading}
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin
	};
};

export default connect(
	mapStateToProps,
	{ userTokenUpdate, getBanners }
)(BannerItem);



// WEBPACK FOOTER //
// ./src/components/admin/banners/BannerItem.js